"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const videoTeaser = Array.from(document.querySelectorAll('[data-gs1-videoteaser]'));
const documentBody = document.querySelector('body');
// Add UI blocker...
const documentBlocker = document.createElement('div');
documentBlocker.classList.add('modal__blocker');
if (videoTeaser) {
    videoTeaser.forEach((teaser) => {
        const removeDocumentBlocker = () => {
            if (documentBlocker) {
                const blockers = document.querySelectorAll(".modal__blocker");
                for (let blocker of blockers) {
                    blocker.remove();
                }
            }
        };
        // Build the video player code based on »GS1 Videoteaser« content element contents and append it to the video player modal.
        const initVideoPlayer = (code) => {
            removeDocumentBlocker();
            let videoPanel = document.querySelector(`#${code.getAttribute('data-videoplayer-id')}`);
            videoPanel.classList.remove('hidden');
            const videoteaserTitle = teaser.getAttribute('data-gs1-videoteaser-title');
            let siteOriginUrl = document.querySelector('[data-gs1-base-url]').getAttribute('data-gs1-base-url');
            const videoString = teaser.getAttribute('data-gs1-videoteaser-link');
            let videoUrl = new URL(videoString);
            let params = new URLSearchParams(videoUrl.search);
            let videoId = '';
            // Remove trailing slash - GS1WEB-4331
            if (siteOriginUrl.substr(-1) === '/') {
                siteOriginUrl = siteOriginUrl.substr(0, siteOriginUrl.length - 1);
            }
            if (params.get("v")) {
                videoId = params.get("v");
            }
            else {
                // Included fallback, just in case the editor decides to place a YouTube URL of the format youtu.be/videoid (yes, they have done that before)
                // in which case there, obviously, is no v-param to look for, so we'll simply grab the URL to get the ID for the embed code.
                videoId = videoUrl.pathname.split("/")[1];
            }
            let modalInner = videoPanel.querySelector('.modal__inner-text');
            let playerWidth = modalInner.offsetWidth;
            let playerHeight = playerWidth / 16 * 9;
            modalInner.innerHTML = `<iframe width="` + playerWidth + `" height="` + playerHeight + `" id="${code.getAttribute('data-player-id')}" src="https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1&rel=0&origin=${siteOriginUrl}" title="${videoteaserTitle}" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`;
            documentBody.appendChild(documentBlocker);
        };
        const stopVideoPlayer = (code) => {
            if (code !== null) {
                const video = document.querySelector(`#${code.getAttribute('data-videoplayer-id')}`);
                let iframe;
                if (video) {
                    iframe = video.children[0].children[0].children[0];
                }
                iframe.contentWindow.postMessage('{"event":"command","func":"stopVideo","args":""}', '*');
                iframe.src = '';
            }
            removeDocumentBlocker();
        };
        teaser.addEventListener("click", (event) => {
            event.preventDefault();
            const videoPanel = document.querySelector(`#${teaser.closest('[data-gs1-videoteaser]').getAttribute('data-videoplayer-id')}`);
            const consentPanel = document.querySelector(`#videoTeaserConsent${teaser.closest('[data-gs1-videoteaser]').getAttribute('data-videoplayer-id').split("r")[1]}`);
            // In case videoteasers are used within slider elements, we have to do some DOM reshuffling,
            // to have those modal views outside of the slider, so they don't open behind the UI blocker and don't open within the small space of the slider (due to positioning conflicts)
            if (teaser.closest('.gs1-slider')) {
                const consentPanels = document.querySelectorAll('[data-gs1-videoteaser-consent-panel]');
                const videoPanels = document.querySelectorAll('[data-gs1-videoteaser-video-panel]');
                // Reshuffle the modal views in the DOM
                consentPanels.forEach((consentPanel) => {
                    documentBody.insertAdjacentElement("beforeend", consentPanel);
                });
                videoPanels.forEach((videoPanel) => {
                    documentBody.insertAdjacentElement("beforeend", videoPanel);
                });
            }
            // Check if user has decided to remember his GDPR decision.
            if (localStorage.getItem('GS1_YT_VIDEO_CONSENT')) {
                initVideoPlayer(teaser);
                if (!videoPanel.classList.contains('hidden')) {
                    if (!consentPanel.classList.contains('hidden')) {
                        consentPanel.classList.add('hidden');
                    }
                    videoPanel.addEventListener("click", (event) => {
                        stopVideoPlayer(teaser);
                        videoPanel.classList.add('hidden');
                    });
                }
            }
            else {
                // If the user hasn't consented yet, we'll show them the GDPR consent flow (each time they open a video, unless they decide to check »remember decision«).
                const confirmButton = consentPanel.querySelector('[data-gs1-videoteaser-confirm]');
                const denyButton = consentPanel.querySelector('[data-gs1-videoteaser-deny]');
                confirmButton.addEventListener("click", (event) => {
                    // Check if the user has decided to keep his decision on GDPR consent for all videos.
                    const rememberConsent = () => {
                        const currentDateString = new Date(Date.now());
                        localStorage.setItem("GS1_YT_VIDEO_CONSENT", `${currentDateString}`);
                    };
                    const optIntoAll = document.querySelector('#' + confirmButton.getAttribute('data-accept-all-id'));
                    (optIntoAll.checked) ? rememberConsent() : '';
                    consentPanel.classList.add('hidden');
                    // Finally initialize video player again.
                    initVideoPlayer(teaser);
                    if (!videoPanel.classList.contains('hidden')) {
                        videoPanel.addEventListener("click", (event) => {
                            stopVideoPlayer(teaser);
                            videoPanel.classList.add('hidden');
                        });
                    }
                });
                denyButton.addEventListener("click", (event) => {
                    consentPanel.classList.add('hidden');
                    const uiBlocker = document.querySelector('.modal__blocker');
                    (uiBlocker) ? uiBlocker.remove() : '';
                });
            }
        });
    });
}
exports.default = {};
